import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import BrandIconCard from '../../components/BrandIconCard/BrandIconCard';

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStatic: true,
      activeTab: 'language',
    };
  }

  handleTabClick = tab => {
    this.setState({ activeTab: tab });
  };

  renderTabContent() {
    const { activeTab } = this.state;
    const { publicData, config } = this.props;
    const { language, packing_list, house_rules } = publicData || {};
    const fields = config?.listing.listingFields || []; 
    const getLabel = (fieldKey, value) => { 
      const field = fields.find(f => f.key === fieldKey);
      if (!field || !field.enumOptions) return value;
  
      const normalizedValue = value?.toLowerCase().trim();
      const matchedOption = field.enumOptions.find(opt =>
        opt.option?.toLowerCase().trim() === normalizedValue
      ); 
      return matchedOption?.label || value;
    }; 
    const renderList = (fieldKey, dataArray) => (
      <ul className={css.languageList}>
        {dataArray?.map((item, index) => ( 
          <li key={index}>{getLabel(fieldKey, item)}</li>
        ))}
      </ul>
    ); 
    switch (activeTab) {
      case 'language':
        return renderList('language', language);
      case 'packing':
        return renderList('packing_list', packing_list);
      case 'rules':
        return renderList('house_rules', house_rules);
      default:
        return null;
    }
  }
  
  

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig,config } = this.props;
    const { isStatic, activeTab } = this.state; 
    if (!geolocation) {
      return null;
    }  
    const whereYoullBe = publicData?.where_youll_be || '';
    const {how_to_get_there,private_transfers,public_transportation,self_drive ,helpFulLink    } = publicData || {};
    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} />;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>
        <p className={css.sectionDescription}>{whereYoullBe}</p>
        <div className={css.mapWrapper}>
          {/* {isStatic ? (
            <button
              className={css.mapImage}
              onClick={() => {
                this.setState({ isStatic: false });
              }}
            >
              {map}
            </button>
          ) : ( */}
            <div className={css.map}>{map}</div>
          {/* )} */}

          {/* Extra Info Section */}
          <div className={css.locationSection}>
            {/* Left Column */}
            <div>
              <div className={css.locationGet}>How to get there</div>
              <ul className={css.locationList}>
                {how_to_get_there?.length > 0 && <li>{how_to_get_there}</li>}
                {private_transfers?.length > 0 && <li>{private_transfers}</li>}
                {public_transportation?.length > 0 && <li>{public_transportation}</li>}
                {self_drive?.length > 0 && <li>{self_drive}</li>}

                {helpFulLink?.length > 0 && (
                  <li>
                    <strong>Helpful Links:</strong>{' '}
                    {helpFulLink
                      .split(',')
                      .map(link => link.trim())
                      .filter(link => link.length > 0)
                      .map((link, index, array) => (
                        <span key={index}>
                          <a
                            href={link.match(/(https?:\/\/[^\s]+)/)?.[0] || '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link}
                          </a>
                          {index < array.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                  </li>
                )}
              </ul>
            </div>

            {/* Right Column */}
            <div>
              <div className={css.onSiteHeading}>On Site</div>
              <div className={css.onSiteList}>
                {['language', 'packing', 'rules'].map(tab => (
                  <button
                    className={css.tabButton}
                    key={tab}
                    onClick={() => this.handleTabClick(tab)}
                    style={{
                      color: activeTab === tab ? '#fff' : '#000',
                      backgroundColor: activeTab === tab ? '#247266' : '#fff',
                      // borderBottom: activeTab === tab ? 'none' : '1px solid #ccc',
                    }}
                  >
                    {tab === 'language'
                      ? 'Language'
                      : tab === 'packing'
                      ? 'Packing List'
                      : 'House Rules'}
                  </button>
                ))}
              </div>
              {this.renderTabContent()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SectionMapMaybe;
